import { useEffect } from 'react';

import { SCAN_EVENT_QUEUE } from '../constants/scanEventQueue.const';
import { createRawScanEvent } from '../utils/createRawScanEvent.util';
import { createScanDetector } from '../utils/scanDetector.util';

/**
 * Mounts scan detection and enqueues raw events.
 */
export const useScanDetection = () => {
  useEffect(() => {
    const detector = createScanDetector({
      onScan: (barcodeValue) => {
        SCAN_EVENT_QUEUE.enqueue(createRawScanEvent(barcodeValue));
      },
    });

    detector.start();

    return detector.stop;
  }, []);
};
